export default __webpack_public_path__ + "static/media/img4.6aa3b96b.png";